import React from 'react';
import ContactListBase from './ContactListBase';
import { useAdminOnlyContactTypes } from './contactTypeOptions';

// Lists the clients, both organizations and private persons, the admin
// environment also lists its cancelled customers with a type filter
const ClientList: React.FC = () => {
    const adminOnlyTypes = useAdminOnlyContactTypes();
    const listedTypes = ['client', ...adminOnlyTypes];

    return (
        <ContactListBase
            listKey='contact_client'
            objectName='client.general.object_name'
            defaultParams={{ contact_type_filter: listedTypes.join(',') }}
            formLinkedItem={{ contact_type: 'client' }}
            showTypeFilter={adminOnlyTypes.length > 0}
            typeFilterOptions={listedTypes}
            showEntityTypeFilter
            showNumberColumn
        />
    );
};

export default ClientList;
